/**
 * Created by Ivan on 20.11.2025
 */

const SpecialEnergyOfferRowView = function () {
    return Prefab.instantiate(bundles.questsgroupicon.jsons.specialenergyofferrow_prefab_json);
};
